module.exports = "https://static.im-cdn.com/mjc/storefront/Sakra/static/media/Gift.28803277.svg";